import apiClient from '@/services/axios'
import { transformIntoQuery } from '@/utils/pagination'

class OrderService {
  constructor() {
    this.$api = apiClient
  }

  getNewOrders () {
    return this.$api.get('/admin/seller-orders?new-only=true')
  }

  getOrders (pagination, sorting, filter) {
    const query = transformIntoQuery(pagination, sorting, filter)
    return this.$api.get(`/admin/seller-orders${query}`)
  }

  getOrder (orderId) {
    return this.$api.get(`/admin/seller-orders/${orderId}`)
  }

  fetchNotes (orderId) {
    return this.$api.get(`/admin/seller-orders/${orderId}/notes`)
  }

  fetchStatusHistory (orderId) {
    return this.$api.get(`/admin/seller-orders/${orderId}/status-history`)
  }

  acceptOrder (orderId) {
    return this.$api.patch(`/admin/seller-orders/${orderId}/accept`)
  }

  confirmOrderDelivery (orderId) {
    return this.$api.patch(`/admin/seller-orders/${orderId}/confirm-delivery`)
  }

  declineOrder (orderId, reason) {
    return this.$api.patch(`/admin/seller-orders/${orderId}/decline?reason=${reason}`)
  }

  declineInProgressOrder(orderId) {
    return this.$api.patch(`/admin/seller-orders/${orderId}`)
  }

  dispatchOrder (orderId, comment, trackingNumber) {
    let query = ''
    if (comment && comment.length > 0)
      query += `comment=${comment}`

    if (trackingNumber && trackingNumber.length > 0)
      query += (query.length > 0 ? '&' : '' + `tracking_no=${trackingNumber}`)

    if (query.length > 0)
      query = `?${query}`

    return this.$api.patch(`/admin/seller-orders/${orderId}/dispatch${query}`)
  }

  acceptOrderReturn (orderId) {
    return this.$api.patch(`/admin/seller-orders/${orderId}/return/accept`)
  }

  declineOrderReturn (orderId, reason) {
    return this.$api.patch(`/admin/seller-orders/${orderId}/return/decline?reason=${reason}`)
  }

  getReturnApplications (pagination, sorting, filter) {
    const query = transformIntoQuery(pagination, sorting, filter)
    return this.$api.get(`/admin/return-applications${query}`)
  }

  getReturnApplication (applicationId) {
    return this.$api.get(`/admin/return-applications/${applicationId}`)
  }

  acceptReturnApplication (appId, payload) {
    return this.$api.put(`/admin/return-applications/courier/${appId}`, payload)
  }

  declineReturnApplication({ declineReason, declineImagesList, id }) {
    const body = new FormData()
    declineImagesList.forEach(image => {
      body.append('image', image.originFileObj)
    })
    body.append('reason', declineReason)
    return this.$api.put(`/admin/return-applications/reject/${id}`, body)
  }

  handleFinalVerdict(id, payload) {
    return this.$api.put(`/admin/return-applications/${id}`, payload)
  }

  getReturnAppBlank(id) {
    return this.$api.get(`admin/return-applications/blankInfo/${id}`)
  }

  createAdminReturnApplication(orderId, payload) {
    return this.$api.put(`/admin/return-applications/${orderId}/return`, payload)
  }

  uploadApplicationDocument (appId, payload) {
    const body = new FormData()
    body.append('file', payload)
    return this.$api.post(`/admin/return-applications/${appId}?file=MultipartFile`, body, {})
  }

  assignReturnApplication (payload) {
    return this.$api.post('/admin/return-applications/post-branch-return', payload)
  }
}

export default new OrderService()
